import React, { useEffect, useState } from "react";
import DashboardHelper from "../../helpers/DashboardHelper";
import SeasonalAveragesTable from "./SeasonalAveragesTable";
import AreaAverageGraph from "./AreaAverageGraph";
import AreaService from "../../api-service/AreaService";
import { EMPTY } from "../../configurations/Constants";
import { ERROR_LOADING_AREA_AVERAGES } from "../../configurations/MessageConstants";

function SeasonalAverages() {
  let yearArray = DashboardHelper.setYearDataArray([]);
  const [areaInches, setAreaInches] = useState(Array(16).fill("0.00"));
  const [cornInches, setCornInches] = useState(Array(16).fill("0.00"));
  const [soybeanInches, setSoybeanInches] = useState(Array(16).fill("0.00"));

  const HandleSeasonalYear = () => {
    let seasonalYear = yearArray[0];
    const currentDate = new Date().getTime();
    const seasonChangeDate = new Date(`15/APR/${seasonalYear.value}`).getTime();
    if (currentDate < seasonChangeDate) {
      yearArray = yearArray.slice(1);
      seasonalYear = yearArray[0];
    }
    return seasonalYear;
  };
  const [selectedYear, setSelectedYear] = useState(HandleSeasonalYear());

  useEffect(() => {
    generateUrl();
  }, [selectedYear]);

  const generateUrl = () => {
    let params = EMPTY;
    if (selectedYear) params = `?year=${selectedYear.value}`;
    LoadAreas(params);
  };

  const LoadAreas = async (params) => {
    try {
      const { data } = await AreaService.getAreaAverageGraph(params);
      setAreaInches(data.data.crops);
      setCornInches(data.data.corn);
      setSoybeanInches(data.data.soybean);
    } catch (error) {
      console.error(ERROR_LOADING_AREA_AVERAGES, error);
    }
  };

  return (
    <div className="seasonal-averages-body">
      <AreaAverageGraph
        areaInches={areaInches}
        cornInches={cornInches}
        soybeanInches={soybeanInches}
        selectedYear={selectedYear}
      />
      <SeasonalAveragesTable
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        yearArray={yearArray}
      />
    </div>
  );
}

export default SeasonalAverages;
